// @ts-nocheck
import { capitalize, find, get } from 'lodash'
import { AntdPopconfirm, Icon, FormFieldLayout } from '../../generic'
import { colors } from '@lmc/common/constants'
import AnimateHeight from 'react-animate-height'
import RiskValue from '../../carePlans/RiskValue'
import { theme } from '@lmc/ui-kit'

const handleClick = (props) => {
  const { formKey, i, onChange, option, requireConfirm } = props

  return requireConfirm
    ? () => {}
    : onChange({
        key: formKey,
        value: option.risk ? i : option.value
      })
}

export default function RadiosField(props) {
  const {
    confirmProps,
    errors,
    formKey,
    optionFieldStyle,
    optionIconStyle,
    optionLabelStyle,
    options,
    onConfirm,
    readOnly,
    requireConfirm,
    selectedOptionFieldStyle,
    style,
    withDescription,
    values,
    disabled,
    floatHelpLink
  } = props

  const currentValue = get(values, formKey)
  const error = get(errors, formKey)
  const selectedOption = getSelectedOption(currentValue, options)

  if (readOnly && selectedOption) {
    return (
      <div
        className={
          selectedOption.risk
            ? 'lmc-risk-option-field-read-only'
            : 'lmc-option-field-read-only'
        }
      >
        <div style={styles.valueContainer}>
          {selectedOption.risk && (
            <RiskValue
              risk={selectedOption.risk}
              value={selectedOption.value}
            />
          )}
          <span
            style={{
              ...styles.radioLabel,
              alignSelf: !withDescription ? 'center' : ''
            }}
          >
            {selectedOption.label || capitalize(selectedOption.value)}
          </span>
        </div>
      </div>
    )
  }

  return (
    <FormFieldLayout
      hasErrors={!!error}
      layout={withDescription ? 'no-label' : 'row'}
      {...props}
      floatHelpLink={floatHelpLink}
    >
      <div className="lmc-field-confirm">
        <AntdPopconfirm
          confirmProps={confirmProps}
          disabled={!requireConfirm}
          onConfirm={onConfirm}
        >
          <div style={{ ...style, ...styles.wrapper }}>
            {options.map((option, i) => {
              const isSelected = option === selectedOption

              const selectedStyle = isSelected ? selectedOptionFieldStyle : null

              let borderColor
              if (error) {
                borderColor = colors.red
              } else if (!withDescription && isSelected) {
                borderColor = theme.color.status.primary
              } else {
                borderColor = colors.grey
              }

              return (
                <div
                  className="lmc-option-field"
                  data-cy={
                    typeof option?.label === 'string' &&
                    option?.label?.replaceAll(' ', '-')
                  }
                  data-testid={
                    props.testId
                      ? `${props.testId}-${formKey}-${typeof option?.label === 'string' ? option.label.replaceAll(' ', '-') : `option-${i}`}`
                      : `${formKey}-${typeof option?.label === 'string' ? option.label.replaceAll(' ', '-') : `option-${i}`}`
                  }
                  key={i}
                  onClick={() =>
                    !disabled && handleClick({ ...props, option, i })
                  }
                  style={{
                    borderColor,
                    ...optionFieldStyle,
                    ...selectedStyle,
                    ...(disabled && styles.disabledStyle),
                    ...(withDescription && styles.optionContainer)
                  }}
                >
                  <div
                    style={{
                      ...styles.valueContainer,
                      ...(withDescription && styles.baselineContainer),
                      ...optionLabelStyle
                    }}
                  >
                    {option.risk && (
                      <RiskValue risk={option.risk} value={option.value} />
                    )}
                    <div
                      style={{ ...(withDescription && styles.textContainer) }}
                    >
                      <span
                        style={{
                          ...styles.radioLabel,
                          fontWeight: withDescription ? 500 : 'initial'
                        }}
                      >
                        {option.label || capitalize(option.value)}
                      </span>
                      {option.description && withDescription && (
                        <span style={styles.radioDescription}>
                          {option.description}
                        </span>
                      )}
                    </div>
                  </div>
                  <Icon
                    name={isSelected ? 'radio-on' : 'radio-off'}
                    fill={isSelected ? theme.color.status.primary : null}
                    size={24}
                    style={{ ...styles.icon, ...optionIconStyle }}
                  />
                </div>
              )
            })}
          </div>
        </AntdPopconfirm>
      </div>
      <AnimateHeight animateOpacity duration={200} height={error ? 'auto' : 0}>
        <div style={styles.error}>{error}</div>
      </AnimateHeight>
    </FormFieldLayout>
  )
}

const getSelectedOption = (currentValue, options) =>
  options && options[0] && options[0].risk
    ? options[currentValue]
    : find(options, { value: currentValue })

const styles = {
  radioLabel: {
    display: 'block',
    lineHeight: '22px',
    marginRight: 5
  },
  radioDescription: {
    fontSize: 12,
    color: colors.silver
  },
  error: {
    color: colors.red,
    fontSize: 11,
    paddingTop: 2
  },
  icon: {
    flexShrink: 0
  },
  valueContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  baselineContainer: {
    marginBottom: 'auto',
    marginTop: 0
  },
  wrapper: {
    display: 'flex',
    flexFlow: 'row wrap',
    marginBottom: '-12px'
  },
  optionContainer: {
    width: 240,
    background: colors.background,
    alignItems: 'baseline',
    borderRadius: 9
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  disabledStyle: {
    pointerEvents: 'none',
    background: '#fafafa',
    opacity: 0.39
  }
}
